import ProposalsAccess from "./ProposalsAccess";

export default ProposalsAccess;
